import PropTypes from 'prop-types';

const FacetPanelLoading = ({ title, extraClassName }) => {
  return (
    <div className="lp-filter-group lp-filter-loading">
      <div className="lp-filter-head">
        <h4 className="lp-filter-title m-0 py-3 text-sm text-gray-800 font-bold">
          {title ? (
            <span className="name" title={title}>
              {title}
            </span>
          ) : (
            <div className="lp-loading-bg w-1/3"></div>
          )}
          <i className="lp-icon-arrow fa-regular fa-angle-right" />
        </h4>
      </div>
      <div className={`lp-filter-body pb-2 -mt-1 ${extraClassName}`}>
        <ul className="lp-filter-list">
          <li className="lp-filter-item">
            <div className="lp-loading-bg"></div>
          </li>
          <li className="lp-filter-item">
            <div className="lp-loading-bg"></div>
          </li>
        </ul>
      </div>
      <hr className="mt-3 mb-0 border border-gray-100" />
    </div>
  );
};

FacetPanelLoading.propTypes = {
  title: PropTypes.string,
  extraClassName: PropTypes.string
};

FacetPanelLoading.defaultProps = {
  extraClassName: ''
};

export default FacetPanelLoading;
